import * as React from "react";
export var AVAILABLE_UI_THEMES = ["default", "sunset", "ocean", "forest"];
export var DEFAULT_UI_THEME = "default";
export var getDataUiTheme = function () {
    var _a;
    if (typeof window === "undefined") {
        return DEFAULT_UI_THEME;
    }
    var rootTheme = document.documentElement.getAttribute("data-ui-theme");
    if (rootTheme && AVAILABLE_UI_THEMES.includes(rootTheme)) {
        return rootTheme;
    }
    var session = window.session;
    var theme = (_a = session === null || session === void 0 ? void 0 : session.store) === null || _a === void 0 ? void 0 : _a.theme;
    if (typeof theme === "string" && AVAILABLE_UI_THEMES.includes(theme)) {
        return theme;
    }
    return DEFAULT_UI_THEME;
};
export var useDataUiTheme = function () {
    var _a = React.useState(getDataUiTheme), uiTheme = _a[0], setUiTheme = _a[1];
    React.useEffect(function () {
        if (typeof window === "undefined" || typeof MutationObserver === "undefined") {
            return;
        }
        var rootElement = document.documentElement;
        var updateUiTheme = function () {
            setUiTheme(getDataUiTheme());
        };
        updateUiTheme();
        var observer = new MutationObserver(function () {
            updateUiTheme();
        });
        observer.observe(rootElement, {
            attributes: true,
            attributeFilter: ["data-ui-theme"],
        });
        return function () {
            observer.disconnect();
        };
    }, []);
    return uiTheme;
};
